import { useContext } from "react";
import { AuthStateContext } from "./context";
import type { AuthState } from "./context";

export type { AuthState, Identity, LoginOptions } from "./context";

/**
 * Vendor-neutral auth hook. Reads the shared [AuthStateContext] that BOTH the OIDC path
 * (`AuthProvider` in oidc mode) and the dev-only stub path (`VITE_AUTH_MODE=stub`) populate,
 * so consuming apps never know — or branch on — which mode is active.
 */
export function useAuth(): AuthState {
  const state = useContext(AuthStateContext);
  if (!state) {
    throw new Error("useAuth must be used within <AuthProvider> (@repo/auth)");
  }
  return state;
}
